export type Coordinate = any[] | boolean | number | number | null | CoordinateObject | string;

export interface CoordinateObject {
    COFINS?:     TNFeInfNFeDetImpostoCOFINS;
    COFINSST?:   TNFeInfNFeDetImpostoCOFINSST;
    ICMS?:       TNFeInfNFeDetImpostoICMS;
    ICMSUFDest?: TNFeInfNFeDetImpostoICMSUFDest;
    II?:         TNFeInfNFeDetImpostoII;
    IPI?:        TIpi;
    ISSQN?:      TNFeInfNFeDetImpostoISSQN;
    NFe?:        TNFe;
    PIS?:        TNFeInfNFeDetImpostoPIS;
    PISST?:      TNFeInfNFeDetImpostoPISST;
    Signature?:  SignatureType;
    vTotTrib?:   string;
    [property: string]: any;
}

export interface TNFeInfNFeDetImpostoCOFINS {
    cofinsAliq: TNFeInfNFeDetImpostoCOFINSCOFINSAliq;
    cofinsnt:   TNFeInfNFeDetImpostoCOFINSCOFINSNT;
    cofinsOutr: TNFeInfNFeDetImpostoCOFINSCOFINSOutr;
    cofinsQtde: TNFeInfNFeDetImpostoCOFINSCOFINSQtde;
    [property: string]: any;
}

export interface TNFeInfNFeDetImpostoCOFINSCOFINSAliq {
    cst:     ModEnum;
    pcofins: string;
    vbc:     string;
    vcofins: string;
    [property: string]: any;
}

export enum ModEnum {
    The01 = "01",
    The02 = "02",
}

export interface TNFeInfNFeDetImpostoCOFINSCOFINSOutr {
    cst:       CofinsOutrCst;
    pcofins:   string;
    qbcProd:   string;
    vAliqProd: string;
    vbc:       string;
    vcofins:   string;
    [property: string]: any;
}

export enum CofinsOutrCst {
    The49 = "49",
    The50 = "50",
    The51 = "51",
    The52 = "52",
    The53 = "53",
    The54 = "54",
    The55 = "55",
    The56 = "56",
    The60 = "60",
    The61 = "61",
    The62 = "62",
    The63 = "63",
    The64 = "64",
    The65 = "65",
    The66 = "66",
    The67 = "67",
    The70 = "70",
    The71 = "71",
    The72 = "72",
    The73 = "73",
    The74 = "74",
    The75 = "75",
    The98 = "98",
    The99 = "99",
}

export interface TNFeInfNFeDetImpostoCOFINSCOFINSQtde {
    cst:       CofinsQtdeCst;
    qbcProd:   string;
    vAliqProd: string;
    vcofins:   string;
    [property: string]: any;
}

export enum CofinsQtdeCst {
    The03 = "03",
}

export interface TNFeInfNFeDetImpostoCOFINSCOFINSNT {
    cst: CofinsntCst;
    [property: string]: any;
}

export enum CofinsntCst {
    The04 = "04",
    The05 = "05",
    The06 = "06",
    The07 = "07",
    The08 = "08",
    The09 = "09",
}

export interface TNFeInfNFeDetImpostoCOFINSST {
    indSomaCOFINSST?: IndSomaCofinsst;
    pcofins:          string;
    qbcProd:          string;
    vAliqProd:        string;
    vbc:              string;
    vcofins:          string;
    [property: string]: any;
}

export enum IndSomaCofinsst {
    The0 = "0",
    The1 = "1",
}

export interface TNFeInfNFeDetImpostoICMS {
    icms00:    TNFeInfNFeDetImpostoICMSICMS00;
    icms10:    TNFeInfNFeDetImpostoICMSICMS10;
    icms20:    TNFeInfNFeDetImpostoICMSICMS20;
    icms30:    TNFeInfNFeDetImpostoICMSICMS30;
    icms40:    TNFeInfNFeDetImpostoICMSICMS40;
    icms51:    TNFeInfNFeDetImpostoICMSICMS51;
    icms60:    TNFeInfNFeDetImpostoICMSICMS60;
    icms70:    TNFeInfNFeDetImpostoICMSICMS70;
    icms90:    TNFeInfNFeDetImpostoICMSICMS90;
    icmsPart:  TNFeInfNFeDetImpostoICMSICMSPart;
    icmssn101: TNFeInfNFeDetImpostoICMSICMSSN101;
    icmssn102: TNFeInfNFeDetImpostoICMSICMSSN102;
    icmssn201: TNFeInfNFeDetImpostoICMSICMSSN201;
    icmssn202: TNFeInfNFeDetImpostoICMSICMSSN202;
    icmssn500: TNFeInfNFeDetImpostoICMSICMSSN500;
    icmssn900: TNFeInfNFeDetImpostoICMSICMSSN900;
    icmsst:    TNFeInfNFeDetImpostoICMSICMSST;
    [property: string]: any;
}

export interface TNFeInfNFeDetImpostoICMSICMS00 {
    cst:   Icms00Cst;
    modBC: ModBc;
    orig:  Orig;
    pfcp:  string;
    picms: string;
    vbc:   string;
    vfcp:  string;
    vicms: string;
    [property: string]: any;
}

export enum Icms00Cst {
    The00 = "00",
}

export enum ModBc {
    The0 = "0",
    The1 = "1",
    The2 = "2",
    The3 = "3",
}

export enum Orig {
    The0 = "0",
    The1 = "1",
    The2 = "2",
    The3 = "3",
    The4 = "4",
    The5 = "5",
    The6 = "6",
    The7 = "7",
    The8 = "8",
}

export interface TNFeInfNFeDetImpostoICMSICMS10 {
    cst:          Icms10Cst;
    modBC:        ModBc;
    modBCST:      ModBCST;
    motDesICMSST: MotDESIcms;
    orig:         Orig;
    pfcp:         string;
    pfcpst:       string;
    picms:        string;
    picmsst:      string;
    pmvast?:      string;
    pRedBCST?:    string;
    vbc:          string;
    vbcfcp:       string;
    vbcfcpst:     string;
    vbcst:        string;
    vfcp:         string;
    vfcpst:       string;
    vicms:        string;
    vicmsst:      string;
    vicmsstDeson: string;
    [property: string]: any;
}

export enum Icms10Cst {
    The10 = "10",
}

export enum ModBCST {
    The0 = "0",
    The1 = "1",
    The2 = "2",
    The3 = "3",
    The4 = "4",
    The5 = "5",
    The6 = "6",
}

export enum MotDESIcms {
    The12 = "12",
    The3 = "3",
    The9 = "9",
}

export interface TNFeInfNFeDetImpostoICMSICMS20 {
    cst:        Icms20Cst;
    modBC:      ModBc;
    motDesICMS: MotDESIcms;
    orig:       Orig;
    pfcp:       string;
    picms:      string;
    pRedBC:     string;
    vbc:        string;
    vbcfcp:     string;
    vfcp:       string;
    vicms:      string;
    vicmsDeson: string;
    [property: string]: any;
}

export enum Icms20Cst {
    The20 = "20",
}

export interface TNFeInfNFeDetImpostoICMSICMS30 {
    cst:        Icms30Cst;
    modBCST:    ModBCST;
    motDesICMS: Icms30MotDESICMS;
    orig:       Orig;
    pfcpst:     string;
    picmsst:    string;
    pmvast?:    string;
    pRedBCST?:  string;
    vbcfcpst:   string;
    vbcst:      string;
    vfcpst:     string;
    vicmsDeson: string;
    vicmsst:    string;
    [property: string]: any;
}

export enum Icms30Cst {
    The30 = "30",
}

export enum Icms30MotDESICMS {
    The6 = "6",
    The7 = "7",
    The9 = "9",
}

export interface TNFeInfNFeDetImpostoICMSICMS40 {
    cst:        Icms40Cst;
    motDesICMS: Icms40MotDESICMS;
    orig:       Orig;
    vicmsDeson: string;
    [property: string]: any;
}

export enum Icms40Cst {
    The40 = "40",
    The41 = "41",
    The50 = "50",
}

export enum Icms40MotDESICMS {
    The1 = "1",
    The10 = "10",
    The11 = "11",
    The16 = "16",
    The3 = "3",
    The4 = "4",
    The5 = "5",
    The6 = "6",
    The7 = "7",
    The8 = "8",
    The9 = "9",
    The90 = "90",
}

export interface TNFeInfNFeDetImpostoICMSICMS51 {
    cst:       Icms51Cst;
    modBC?:    ModBc;
    orig:      Orig;
    pDif?:     string;
    pfcp:      string;
    pfcpDif?:  string;
    picms?:    string;
    pRedBC?:   string;
    vbc?:      string;
    vbcfcp:    string;
    vfcp:      string;
    vfcpDif?:  string;
    vfcpEfet?: string;
    vicms?:    string;
    vicmsDif?: string;
    vicmsOp?:  string;
    [property: string]: any;
}

export enum Icms51Cst {
    The51 = "51",
}

export interface TNFeInfNFeDetImpostoICMSICMS60 {
    cst:              Icms60Cst;
    orig:             Orig;
    pfcpstRet:        string;
    picmsEfet:        string;
    pRedBCEfet:       string;
    pst:              string;
    vbcEfet:          string;
    vbcfcpstRet:      string;
    vbcstRet:         string;
    vfcpstRet:        string;
    vicmsEfet:        string;
    vicmsstRet:       string;
    vicmsSubstituto?: string;
    [property: string]: any;
}

export enum Icms60Cst {
    The60 = "60",
}

export interface TNFeInfNFeDetImpostoICMSICMS70 {
    cst:          Icms70Cst;
    modBC:        ModBc;
    modBCST:      ModBCST;
    motDesICMS:   MotDESIcms;
    motDesICMSST: MotDESIcms;
    orig:         Orig;
    pfcp:         string;
    pfcpst:       string;
    picms:        string;
    picmsst:      string;
    pmvast?:      string;
    pRedBC:       string;
    pRedBCST?:    string;
    vbc:          string;
    vbcfcp:       string;
    vbcfcpst:     string;
    vbcst:        string;
    vfcp:         string;
    vfcpst:       string;
    vicms:        string;
    vicmsDeson:   string;
    vicmsst:      string;
    vicmsstDeson: string;
    [property: string]: any;
}

export enum Icms70Cst {
    The70 = "70",
}

export interface TNFeInfNFeDetImpostoICMSICMS90 {
    cst:          Icms90Cst;
    modBC:        ModBc;
    modBCST:      ModBCST;
    motDesICMS:   MotDESIcms;
    motDesICMSST: MotDESIcms;
    orig:         Orig;
    pfcp:         string;
    pfcpst:       string;
    picms:        string;
    picmsst:      string;
    pmvast?:      string;
    pRedBC?:      string;
    pRedBCST?:    string;
    vbc:          string;
    vbcfcp:       string;
    vbcfcpst:     string;
    vbcst:        string;
    vfcp:         string;
    vfcpst:       string;
    vicms:        string;
    vicmsDeson:   string;
    vicmsst:      string;
    vicmsstDeson: string;
    [property: string]: any;
}

export enum Icms90Cst {
    The90 = "90",
}

export interface TNFeInfNFeDetImpostoICMSICMSPart {
    cst:       IcmsPartCst;
    modBC:     ModBc;
    modBCST:   ModBCST;
    orig:      Orig;
    pbcOp:     string;
    picms:     string;
    picmsst:   string;
    pmvast?:   string;
    pRedBC?:   string;
    pRedBCST?: string;
    ufst:      TUf;
    vbc:       string;
    vbcst:     string;
    vicms:     string;
    vicmsst:   string;
    [property: string]: any;
}

export enum IcmsPartCst {
    The10 = "10",
    The90 = "90",
}

export enum TUf {
    AC = "AC",
    Al = "AL",
    Am = "AM",
    Ap = "AP",
    Ba = "BA",
    Ce = "CE",
    Df = "DF",
    Es = "ES",
    Ex = "EX",
    Go = "GO",
    MS = "MS",
    MT = "MT",
    Ma = "MA",
    Mg = "MG",
    PE = "PE",
    PR = "PR",
    Pa = "PA",
    Pb = "PB",
    Pi = "PI",
    Rj = "RJ",
    Rn = "RN",
    Ro = "RO",
    Rr = "RR",
    Rs = "RS",
    SE = "SE",
    SP = "SP",
    Sc = "SC",
    To = "TO",
}

export interface TNFeInfNFeDetImpostoICMSICMSSN101 {
    csosn:       Icmssn101Csosn;
    orig:        Orig;
    pCredSN:     string;
    vCredICMSSN: string;
    [property: string]: any;
}

export enum Icmssn101Csosn {
    The101 = "101",
}

export interface TNFeInfNFeDetImpostoICMSICMSSN102 {
    csosn: Icmssn102Csosn;
    orig:  Orig;
    [property: string]: any;
}

export enum Icmssn102Csosn {
    The102 = "102",
    The103 = "103",
    The300 = "300",
    The400 = "400",
}

export interface TNFeInfNFeDetImpostoICMSICMSSN201 {
    csosn:       Icmssn201Csosn;
    modBCST:     ModBCST;
    orig:        Orig;
    pCredSN:     string;
    pfcpst:      string;
    picmsst:     string;
    pmvast?:     string;
    pRedBCST?:   string;
    vbcfcpst:    string;
    vbcst:       string;
    vCredICMSSN: string;
    vfcpst:      string;
    vicmsst:     string;
    [property: string]: any;
}

export enum Icmssn201Csosn {
    The201 = "201",
}

export interface TNFeInfNFeDetImpostoICMSICMSSN202 {
    csosn:     Icmssn202Csosn;
    modBCST:   ModBCST;
    orig:      Orig;
    pfcpst:    string;
    picmsst:   string;
    pmvast?:   string;
    pRedBCST?: string;
    vbcfcpst:  string;
    vbcst:     string;
    vfcpst:    string;
    vicmsst:   string;
    [property: string]: any;
}

export enum Icmssn202Csosn {
    The202 = "202",
    The203 = "203",
}

export interface TNFeInfNFeDetImpostoICMSICMSSN500 {
    csosn:            Icmssn500Csosn;
    orig:             Orig;
    pfcpstRet:        string;
    picmsEfet:        string;
    pRedBCEfet:       string;
    pst:              string;
    vbcEfet:          string;
    vbcfcpstRet:      string;
    vbcstRet:         string;
    vfcpstRet:        string;
    vicmsEfet:        string;
    vicmsstRet:       string;
    vicmsSubstituto?: string;
    [property: string]: any;
}

export enum Icmssn500Csosn {
    The500 = "500",
}

export interface TNFeInfNFeDetImpostoICMSICMSSN900 {
    csosn:       Icmssn900Csosn;
    modBC:       ModBc;
    modBCST:     ModBCST;
    orig:        Orig;
    pCredSN:     string;
    pfcpst:      string;
    picms:       string;
    picmsst:     string;
    pmvast?:     string;
    pRedBC?:     string;
    pRedBCST?:   string;
    vbc:         string;
    vbcfcpst:    string;
    vbcst:       string;
    vCredICMSSN: string;
    vfcpst:      string;
    vicms:       string;
    vicmsst:     string;
    [property: string]: any;
}

export enum Icmssn900Csosn {
    The900 = "900",
}

export interface TNFeInfNFeDetImpostoICMSICMSST {
    cst:              IcmsstCst;
    orig:             Orig;
    pfcpstRet:        string;
    picmsEfet:        string;
    pRedBCEfet:       string;
    pst?:             string;
    vbcEfet:          string;
    vbcfcpstRet:      string;
    vbcstDest:        string;
    vbcstRet:         string;
    vfcpstRet:        string;
    vicmsEfet:        string;
    vicmsstDest:      string;
    vicmsstRet:       string;
    vicmsSubstituto?: string;
    [property: string]: any;
}

export enum IcmsstCst {
    The41 = "41",
    The60 = "60",
}

export interface TNFeInfNFeDetImpostoICMSUFDest {
    pfcpufDest?:    string;
    picmsInter:     PicmsInter;
    picmsInterPart: string;
    picmsufDest:    string;
    vbcfcpufDest?:  string;
    vbcufDest:      string;
    vfcpufDest?:    string;
    vicmsufDest:    string;
    vicmsufRemet:   string;
    [property: string]: any;
}

export enum PicmsInter {
    The1200 = "12.00",
    The400 = "4.00",
    The700 = "7.00",
}

export interface TNFeInfNFeDetImpostoII {
    vbc:      string;
    vDespAdu: string;
    vii:      string;
    viof:     string;
    [property: string]: any;
}

export interface TIpi {
    cEnq:      string;
    cnpjProd?: string;
    cSelo?:    string;
    ipint:     TIpiIPINT;
    ipiTrib:   TIpiIPITrib;
    qSelo?:    string;
    [property: string]: any;
}

export interface TIpiIPITrib {
    cst:   IpiTribCst;
    pipi:  string;
    qUnid: string;
    vbc:   string;
    vipi:  string;
    vUnid: string;
    [property: string]: any;
}

export enum IpiTribCst {
    The00 = "00",
    The49 = "49",
    The50 = "50",
    The99 = "99",
}

export interface TIpiIPINT {
    cst: IpintCst;
    [property: string]: any;
}

export enum IpintCst {
    The01 = "01",
    The02 = "02",
    The03 = "03",
    The04 = "04",
    The05 = "05",
    The51 = "51",
    The52 = "52",
    The53 = "53",
    The54 = "54",
    The55 = "55",
}

export interface TNFeInfNFeDetImpostoISSQN {
    cListServ:    CListServ;
    cMun?:        string;
    cMunFG:       string;
    cPais?:       string;
    cServico?:    string;
    indIncentivo: IndIncentivo;
    indISS:       IndISS;
    nProcesso?:   string;
    vAliq:        string;
    vbc:          string;
    vDeducao?:    string;
    vDescCond?:   string;
    vDescIncond?: string;
    vissqn:       string;
    vissRet?:     string;
    vOutro?:      string;
    [property: string]: any;
}

export enum CListServ {
    The0101 = "01.01",
    The0102 = "01.02",
    The0103 = "01.03",
    The0104 = "01.04",
    The0105 = "01.05",
    The0106 = "01.06",
    The0107 = "01.07",
    The0108 = "01.08",
    The0109 = "01.09",
    The0201 = "02.01",
    The0302 = "03.02",
    The0303 = "03.03",
    The0304 = "03.04",
    The0305 = "03.05",
    The0401 = "04.01",
    The0402 = "04.02",
    The0403 = "04.03",
    The0404 = "04.04",
    The0405 = "04.05",
    The0406 = "04.06",
    The0407 = "04.07",
    The0408 = "04.08",
    The0409 = "04.09",
    The0410 = "04.10",
    The0411 = "04.11",
    The0412 = "04.12",
    The0413 = "04.13",
    The0414 = "04.14",
    The0415 = "04.15",
    The0416 = "04.16",
    The0417 = "04.17",
    The0418 = "04.18",
    The0419 = "04.19",
    The0420 = "04.20",
    The0421 = "04.21",
    The0422 = "04.22",
    The0423 = "04.23",
    The0501 = "05.01",
    The0502 = "05.02",
    The0503 = "05.03",
    The0504 = "05.04",
    The0505 = "05.05",
    The0506 = "05.06",
    The0507 = "05.07",
    The0508 = "05.08",
    The0509 = "05.09",
    The0601 = "06.01",
    The0602 = "06.02",
    The0603 = "06.03",
    The0604 = "06.04",
    The0605 = "06.05",
    The0606 = "06.06",
    The0701 = "07.01",
    The0702 = "07.02",
    The0703 = "07.03",
    The0704 = "07.04",
    The0705 = "07.05",
    The0706 = "07.06",
    The0707 = "07.07",
    The0708 = "07.08",
    The0709 = "07.09",
    The0710 = "07.10",
    The0711 = "07.11",
    The0712 = "07.12",
    The0713 = "07.13",
    The0716 = "07.16",
    The0717 = "07.17",
    The0718 = "07.18",
    The0719 = "07.19",
    The0720 = "07.20",
    The0721 = "07.21",
    The0722 = "07.22",
    The0801 = "08.01",
    The0802 = "08.02",
    The0901 = "09.01",
    The0902 = "09.02",
    The0903 = "09.03",
    The1001 = "10.01",
    The1002 = "10.02",
    The1003 = "10.03",
    The1004 = "10.04",
    The1005 = "10.05",
    The1006 = "10.06",
    The1007 = "10.07",
    The1008 = "10.08",
    The1009 = "10.09",
    The1010 = "10.10",
    The1101 = "11.01",
    The1102 = "11.02",
    The1103 = "11.03",
    The1104 = "11.04",
    The1201 = "12.01",
    The1202 = "12.02",
    The1203 = "12.03",
    The1204 = "12.04",
    The1205 = "12.05",
    The1206 = "12.06",
    The1207 = "12.07",
    The1208 = "12.08",
    The1209 = "12.09",
    The1210 = "12.10",
    The1211 = "12.11",
    The1212 = "12.12",
    The1213 = "12.13",
    The1214 = "12.14",
    The1215 = "12.15",
    The1216 = "12.16",
    The1217 = "12.17",
    The1302 = "13.02",
    The1303 = "13.03",
    The1304 = "13.04",
    The1305 = "13.05",
    The1401 = "14.01",
    The1402 = "14.02",
    The1403 = "14.03",
    The1404 = "14.04",
    The1405 = "14.05",
    The1406 = "14.06",
    The1407 = "14.07",
    The1408 = "14.08",
    The1409 = "14.09",
    The1410 = "14.10",
    The1411 = "14.11",
    The1412 = "14.12",
    The1413 = "14.13",
    The1414 = "14.14",
    The1501 = "15.01",
    The1502 = "15.02",
    The1503 = "15.03",
    The1504 = "15.04",
    The1505 = "15.05",
    The1506 = "15.06",
    The1507 = "15.07",
    The1508 = "15.08",
    The1509 = "15.09",
    The1510 = "15.10",
    The1511 = "15.11",
    The1512 = "15.12",
    The1513 = "15.13",
    The1514 = "15.14",
    The1515 = "15.15",
    The1516 = "15.16",
    The1517 = "15.17",
    The1518 = "15.18",
    The1601 = "16.01",
    The1602 = "16.02",
    The1701 = "17.01",
    The1702 = "17.02",
    The1703 = "17.03",
    The1704 = "17.04",
    The1705 = "17.05",
    The1706 = "17.06",
    The1708 = "17.08",
    The1709 = "17.09",
    The1710 = "17.10",
    The1711 = "17.11",
    The1712 = "17.12",
    The1713 = "17.13",
    The1714 = "17.14",
    The1715 = "17.15",
    The1716 = "17.16",
    The1717 = "17.17",
    The1718 = "17.18",
    The1719 = "17.19",
    The1720 = "17.20",
    The1721 = "17.21",
    The1722 = "17.22",
    The1723 = "17.23",
    The1724 = "17.24",
    The1725 = "17.25",
    The1801 = "18.01",
    The1901 = "19.01",
    The2001 = "20.01",
    The2002 = "20.02",
    The2003 = "20.03",
    The2101 = "21.01",
    The2201 = "22.01",
    The2301 = "23.01",
    The2401 = "24.01",
    The2501 = "25.01",
    The2502 = "25.02",
    The2503 = "25.03",
    The2504 = "25.04",
    The2505 = "25.05",
    The2601 = "26.01",
    The2701 = "27.01",
    The2801 = "28.01",
    The2901 = "29.01",
    The3001 = "30.01",
    The3101 = "31.01",
    The3201 = "32.01",
    The3301 = "33.01",
    The3401 = "34.01",
    The3501 = "35.01",
    The3601 = "36.01",
    The3701 = "37.01",
    The3801 = "38.01",
    The3901 = "39.01",
    The4001 = "40.01",
}

export enum IndISS {
    The1 = "1",
    The2 = "2",
    The3 = "3",
    The4 = "4",
    The5 = "5",
    The6 = "6",
    The7 = "7",
}

export enum IndIncentivo {
    The1 = "1",
    The2 = "2",
}

export interface TNFe {
    infNFe:      TNFeInfNFe;
    infNFeSupl?: TNFeInfNFeSupl;
    signature:   SignatureType;
    [property: string]: any;
}

export interface TNFeInfNFe {
    autXML?:      TNFeInfNFeAutXML[];
    avulsa?:      TNFeInfNFeAvulsa;
    cana?:        TNFeInfNFeCana;
    cobr?:        TNFeInfNFeCobr;
    compra?:      TNFeInfNFeCompra;
    dest?:        TNFeInfNFeDest;
    det:          TNFeInfNFeDet[];
    emit:         TNFeInfNFeEmit;
    entrega?:     TLocal;
    exporta?:     TNFeInfNFeExporta;
    id:           string;
    ide:          TNFeInfNFeIDE;
    infAdic?:     TNFeInfNFeInfAdic;
    infIntermed?: TNFeInfNFeInfIntermed;
    infRespTec?:  TInfRespTec;
    infSolicNFF?: TNFeInfNFeInfSolicNFF;
    pag:          TNFeInfNFePag;
    retirada?:    TLocal;
    total:        TNFeInfNFeTotal;
    transp:       TNFeInfNFeTransp;
    versao:       string;
    [property: string]: any;
}

export interface TNFeInfNFeAutXML {
    cnpj: string;
    cpf:  string;
    [property: string]: any;
}

export interface TNFeInfNFeAvulsa {
    cnpj:    string;
    dEmi?:   string;
    dPag?:   string;
    fone?:   string;
    matr:    string;
    ndar?:   string;
    repEmi:  string;
    uf:      TUfEmi;
    vdar?:   string;
    xAgente: string;
    xOrgao:  string;
    [property: string]: any;
}

export enum TUfEmi {
    AC = "AC",
    Al = "AL",
    Am = "AM",
    Ap = "AP",
    Ba = "BA",
    Ce = "CE",
    Df = "DF",
    Es = "ES",
    Go = "GO",
    MS = "MS",
    MT = "MT",
    Ma = "MA",
    Mg = "MG",
    PE = "PE",
    PR = "PR",
    Pa = "PA",
    Pb = "PB",
    Pi = "PI",
    Rj = "RJ",
    Rn = "RN",
    Ro = "RO",
    Rr = "RR",
    Rs = "RS",
    SE = "SE",
    SP = "SP",
    Sc = "SC",
    To = "TO",
}

export interface TNFeInfNFeCana {
    deduc?:  TNFeInfNFeCanaDeduc[];
    forDia:  TNFeInfNFeCanaForDia[];
    qTotAnt: string;
    qTotGer: string;
    qTotMes: string;
    ref:     string;
    safra:   string;
    vFor:    string;
    vLiqFor: string;
    vTotDed: string;
    [property: string]: any;
}

export interface TNFeInfNFeCanaDeduc {
    vDed: string;
    xDed: string;
    [property: string]: any;
}

export interface TNFeInfNFeCanaForDia {
    dia:  string;
    qtde: string;
    [property: string]: any;
}

export interface TNFeInfNFeCobr {
    dup?: TNFeInfNFeCobrDup[];
    fat?: TNFeInfNFeCobrFat;
    [property: string]: any;
}

export interface TNFeInfNFeCobrDup {
    dVenc?: string;
    nDup?:  string;
    vDup:   string;
    [property: string]: any;
}

export interface TNFeInfNFeCobrFat {
    nFat?:  string;
    vDesc?: string;
    vLiq?:  string;
    vOrig?: string;
    [property: string]: any;
}

export interface TNFeInfNFeCompra {
    xCont?: string;
    xnEmp?: string;
    xPed?:  string;
    [property: string]: any;
}

export interface TNFeInfNFeDest {
    cnpj:          string;
    cpf:           string;
    email?:        string;
    enderDest?:    TEndereco;
    idEstrangeiro: string;
    ie?:           string;
    im?:           string;
    indIEDest:     number;
    isuf?:         string;
    xNome?:        string;
    [property: string]: any;
}

export interface TEndereco {
    cep?:    string;
    cMun:    string;
    cPais?:  string;
    fone?:   string;
    nro:     string;
    uf:      TUf;
    xBairro: string;
    xCpl?:   string;
    xLgr:    string;
    xMun:    string;
    xPais?:  string;
    [property: string]: any;
}

export enum IndIEDest {
    The1 = "1",
    The2 = "2",
    The9 = "9",
}

export interface TNFeInfNFeDet {
    imposto:       TNFeInfNFeDetImposto;
    impostoDevol?: TNFeInfNFeDetImpostoDevol;
    infAdProd?:    string;
    nItem:         string;
    prod:          TNFeInfNFeDetProd;
    [property: string]: any;
}

export interface TNFeInfNFeDetImposto {
    content: Content[];
    [property: string]: any;
}

export interface Content {
    name: string;
    declaredType: string;
    scope: string;
    value: TNFeInfNFeDetImpostoICMS | TNFeInfNFeDetImpostoII | TNFeInfNFeDetImpostoISSQN | TNFeInfNFeDetImpostoPIS | TNFeInfNFeDetImpostoPISST | TNFeInfNFeDetImpostoCOFINS | TNFeInfNFeDetImpostoCOFINSST | TNFeInfNFeDetImpostoICMSUFDest;
    nil: boolean;
    globalScope: boolean;
    typeSubstituted: boolean;
    [property: string]: any;
}

export interface TNFeInfNFeDetImpostoPIS {
    pisAliq: TNFeInfNFeDetImpostoPISPISAliq;
    pisnt:   TNFeInfNFeDetImpostoPISPISNT;
    pisOutr: TNFeInfNFeDetImpostoPISPISOutr;
    pisQtde: TNFeInfNFeDetImpostoPISPISQtde;
    [property: string]: any;
}

export interface TNFeInfNFeDetImpostoPISPISAliq {
    cst:  ModEnum;
    ppis: string;
    vbc:  string;
    vpis: string;
    [property: string]: any;
}

export interface TNFeInfNFeDetImpostoPISPISOutr {
    cst:       CofinsOutrCst;
    ppis:      string;
    qbcProd:   string;
    vAliqProd: string;
    vbc:       string;
    vpis:      string;
    [property: string]: any;
}

export interface TNFeInfNFeDetImpostoPISPISQtde {
    cst:       CofinsQtdeCst;
    qbcProd:   string;
    vAliqProd: string;
    vpis:      string;
    [property: string]: any;
}

export interface TNFeInfNFeDetImpostoPISPISNT {
    cst: CofinsntCst;
    [property: string]: any;
}

export interface TNFeInfNFeDetImpostoPISST {
    indSomaPISST?: IndSomaCofinsst;
    ppis:          string;
    qbcProd:       string;
    vAliqProd:     string;
    vbc:           string;
    vpis:          string;
    [property: string]: any;
}

export interface TNFeInfNFeDetImpostoDevol {
    ipi:    TNFeInfNFeDetImpostoDevolIPI;
    pDevol: string;
    [property: string]: any;
}

export interface TNFeInfNFeDetImpostoDevolIPI {
    vipiDevol: string;
    [property: string]: any;
}

export interface TNFeInfNFeDetProd {
    arma:        TNFeInfNFeDetProdArma[];
    cBarra?:     string;
    cBarraTrib?: string;
    cBenef?:     string;
    cean:        string;
    ceanTrib:    string;
    cest:        string;
    cfop:        string;
    cnpjFab?:    string;
    comb:        TNFeInfNFeDetProdComb;
    cProd:       string;
    detExport?:  TNFeInfNFeDetProdDetExport[];
    di?:         TNFeInfNFeDetProdDI[];
    extipi?:     string;
    indEscala?:  IndEscala;
    indTot:      IndSomaCofinsst;
    infProdEmb?: TNFeInfNFeDetProdInfProdEmb;
    infProdNFF?: TNFeInfNFeDetProdInfProdNFF;
    med:         TNFeInfNFeDetProdMed;
    ncm:         string;
    nfci?:       string;
    nItemPed?:   string;
    nrecopi:     string;
    nve?:        string[];
    qCom:        string;
    qTrib:       string;
    rastro?:     TNFeInfNFeDetProdRastro[];
    uCom:        string;
    uTrib:       string;
    vDesc?:      string;
    veicProd:    TNFeInfNFeDetProdVeicProd;
    vFrete?:     string;
    vOutro?:     string;
    vProd:       string;
    vSeg?:       string;
    vUnCom:      string;
    vUnTrib:     string;
    xPed?:       string;
    xProd:       string;
    [property: string]: any;
}

export interface TNFeInfNFeDetProdArma {
    descr:  string;
    nCano:  string;
    nSerie: string;
    tpArma: IndSomaCofinsst;
    [property: string]: any;
}

export interface TNFeInfNFeDetProdComb {
    cide?:       TNFeInfNFeDetProdCombCIDE;
    codif?:      string;
    cProdANP:    string;
    descANP:     string;
    encerrante?: TNFeInfNFeDetProdCombEncerrante;
    pglp?:       string;
    pgNi?:       string;
    pgNn?:       string;
    qTemp?:      string;
    ufCons:      TUf;
    vPart?:      string;
    [property: string]: any;
}

export interface TNFeInfNFeDetProdCombCIDE {
    qbcProd:   string;
    vAliqProd: string;
    vcide:     string;
    [property: string]: any;
}

export interface TNFeInfNFeDetProdCombEncerrante {
    nBico:   string;
    nBomba?: string;
    nTanque: string;
    vEncFin: string;
    vEncIni: string;
    [property: string]: any;
}

export interface TNFeInfNFeDetProdDetExport {
    exportInd?: TNFeInfNFeDetProdDetExportExportInd;
    nDraw?:     string;
    [property: string]: any;
}

export interface TNFeInfNFeDetProdDetExportExportInd {
    chNFe:   string;
    nre:     string;
    qExport: string;
    [property: string]: any;
}

export interface TNFeInfNFeDetProdDI {
    adi:          TNFeInfNFeDetProdDIAdi[];
    cExportador:  string;
    cnpj?:        string;
    dDesemb:      string;
    ddi:          string;
    ndi:          string;
    tpIntermedio: TpIntermedio;
    tpViaTransp:  TpViaTransp;
    ufDesemb:     TUfEmi;
    ufTerceiro?:  TUfEmi;
    vafrmm?:      string;
    xLocDesemb:   string;
    [property: string]: any;
}

export interface TNFeInfNFeDetProdDIAdi {
    cFabricante: string;
    nAdicao?:    string;
    nDraw?:      string;
    nSeqAdic:    string;
    vDescDI?:    string;
    [property: string]: any;
}

export enum TpIntermedio {
    The1 = "1",
    The2 = "2",
    The3 = "3",
}

export enum TpViaTransp {
    The1 = "1",
    The10 = "10",
    The11 = "11",
    The12 = "12",
    The13 = "13",
    The2 = "2",
    The3 = "3",
    The4 = "4",
    The5 = "5",
    The6 = "6",
    The7 = "7",
    The8 = "8",
    The9 = "9",
}

export enum IndEscala {
    N = "N",
    S = "S",
}

export interface TNFeInfNFeDetProdInfProdEmb {
    qVolEmb: string;
    uEmb:    string;
    xEmb:    string;
    [property: string]: any;
}

export interface TNFeInfNFeDetProdInfProdNFF {
    cOperNFF:   string;
    cProdFisco: string;
    [property: string]: any;
}

export interface TNFeInfNFeDetProdMed {
    cProdANVISA:     string;
    vpmc:            string;
    xMotivoIsencao?: string;
    [property: string]: any;
}

export interface TNFeInfNFeDetProdRastro {
    cAgreg?: string;
    dFab:    string;
    dVal:    string;
    nLote:   string;
    qLote:   string;
    [property: string]: any;
}

export interface TNFeInfNFeDetProdVeicProd {
    anoFab:       string;
    anoMod:       string;
    cCor:         string;
    cCorDENATRAN: string;
    chassi:       string;
    cilin:        string;
    cMod:         string;
    cmt:          string;
    condVeic:     TpIntermedio;
    dist:         string;
    espVeic:      string;
    lota:         string;
    nMotor:       string;
    nSerie:       string;
    pesoB:        string;
    pesoL:        string;
    pot:          string;
    tpComb:       string;
    tpOp:         ModBc;
    tpPint:       string;
    tpRest:       TpREST;
    tpVeic:       string;
    vin:          Vin;
    xCor:         string;
    [property: string]: any;
}

export enum TpREST {
    The0 = "0",
    The1 = "1",
    The2 = "2",
    The3 = "3",
    The4 = "4",
    The9 = "9",
}

export enum Vin {
    N = "N",
    R = "R",
}

export interface TNFeInfNFeEmit {
    cnae?:     string;
    cnpj:      string;
    cpf:       string;
    crt:       TpIntermedio;
    enderEmit: TEnderEmi;
    ie:        string;
    iest?:     string;
    im:        string;
    xFant?:    string;
    xNome:     string;
    [property: string]: any;
}

export interface TEnderEmi {
    cep:     string;
    cMun:    string;
    cPais?:  CPais;
    fone?:   string;
    nro:     string;
    uf:      TUfEmi;
    xBairro: string;
    xCpl?:   string;
    xLgr:    string;
    xMun:    string;
    xPais?:  XPais;
    [property: string]: any;
}

export enum CPais {
    The1058 = "1058",
}

export enum XPais {
    Brasil = "Brasil",
    XPaisBRASIL = "BRASIL",
}

export interface TLocal {
    cep?:    string;
    cmun:    string;
    cnpj:    string;
    cpais?:  string;
    cpf:     string;
    email?:  string;
    fone?:   string;
    ie?:     string;
    nro:     string;
    uf:      TUf;
    xbairro: string;
    xcpl?:   string;
    xlgr:    string;
    xmun:    string;
    xnome?:  string;
    xpais?:  string;
    [property: string]: any;
}

export interface TNFeInfNFeExporta {
    ufSaidaPais:   TUfEmi;
    xLocDespacho?: string;
    xLocExporta:   string;
    [property: string]: any;
}

export interface TNFeInfNFeIDE {
    cdv:          string;
    cMunFG:       string;
    cnf:          string;
    cuf:          Cuf;
    dhCont:       string;
    dhEmi:        string;
    dhSaiEnt?:    string;
    finNFe:       FinNFe;
    idDest:       TpIntermedio;
    indFinal:     IndSomaCofinsst;
    indIntermed?: string;
    indPres:      IndPres;
    mod:          IDEMod;
    natOp:        string;
    nfref?:       TNFeInfNFeIDENFref[];
    nnf:          string;
    procEmi:      ModBc;
    serie:        string;
    tpAmb:        IndIncentivo;
    tpEmis:       TpEmis;
    tpImp:        TpImp;
    tpNF:         IndSomaCofinsst;
    verProc:      string;
    xJust:        string;
    [property: string]: any;
}

export enum Cuf {
    The11 = "11",
    The12 = "12",
    The13 = "13",
    The14 = "14",
    The15 = "15",
    The16 = "16",
    The17 = "17",
    The21 = "21",
    The22 = "22",
    The23 = "23",
    The24 = "24",
    The25 = "25",
    The26 = "26",
    The27 = "27",
    The28 = "28",
    The29 = "29",
    The31 = "31",
    The32 = "32",
    The33 = "33",
    The35 = "35",
    The41 = "41",
    The42 = "42",
    The43 = "43",
    The50 = "50",
    The51 = "51",
    The52 = "52",
    The53 = "53",
}

export enum FinNFe {
    The1 = "1",
    The2 = "2",
    The3 = "3",
    The4 = "4",
}

export enum IndPres {
    The0 = "0",
    The1 = "1",
    The2 = "2",
    The3 = "3",
    The4 = "4",
    The5 = "5",
    The9 = "9",
}

export enum IDEMod {
    The55 = "55",
    The65 = "65",
}

export interface TNFeInfNFeIDENFref {
    refCTe: string;
    refECF: TNFeInfNFeIDENFrefRefECF;
    refNF:  TNFeInfNFeIDENFrefRefNF;
    refNFe: string;
    refNFeSig: string;
    refNFP: TNFeInfNFeIDENFrefRefNFP;
    [property: string]: any;
}

export interface TNFeInfNFeIDENFrefRefECF {
    mod:  RefECFMod;
    ncoo: string;
    necf: string;
    [property: string]: any;
}

export enum RefECFMod {
    The2B = "2B",
    The2C = "2C",
    The2D = "2D",
}

export interface TNFeInfNFeIDENFrefRefNF {
    aamm:  string;
    cnpj:  string;
    cuf:   Cuf;
    mod:   ModEnum;
    nnf:   string;
    serie: string;
    [property: string]: any;
}

export interface TNFeInfNFeIDENFrefRefNFP {
    aamm:  string;
    cnpj:  string;
    cpf:   string;
    cuf:   Cuf;
    ie:    string;
    mod:   RefNFPMod;
    nnf:   string;
    serie: string;
    [property: string]: any;
}

export enum RefNFPMod {
    The01 = "01",
    The04 = "04",
}

export enum TpEmis {
    The1 = "1",
    The2 = "2",
    The3 = "3",
    The4 = "4",
    The5 = "5",
    The6 = "6",
    The7 = "7",
    The9 = "9",
}

export enum TpImp {
    The0 = "0",
    The1 = "1",
    The2 = "2",
    The3 = "3",
    The4 = "4",
    The5 = "5",
}

export interface TNFeInfNFeInfAdic {
    infAdFisco?: string;
    infCpl?:     string;
    obsCont?:    TNFeInfNFeInfAdicObsCont[];
    obsFisco?:   TNFeInfNFeInfAdicObsFisco[];
    procRef?:    TNFeInfNFeInfAdicProcRef[];
    [property: string]: any;
}

export interface TNFeInfNFeInfAdicObsCont {
    xCampo: string;
    xTexto: string;
    [property: string]: any;
}

export interface TNFeInfNFeInfAdicObsFisco {
    xCampo: string;
    xTexto: string;
    [property: string]: any;
}

export interface TNFeInfNFeInfAdicProcRef {
    indProc: IndProc;
    nProc:   string;
    [property: string]: any;
}

export enum IndProc {
    The0 = "0",
    The1 = "1",
    The2 = "2",
    The3 = "3",
    The9 = "9",
}

export interface TNFeInfNFeInfIntermed {
    cnpj:         string;
    idCadIntTran: string;
    [property: string]: any;
}

export interface TInfRespTec {
    cnpj:     string;
    email:    string;
    fone:     string;
    hashCSRT: number[];
    idCSRT:   string;
    xContato: string;
    [property: string]: any;
}

export interface TNFeInfNFeInfSolicNFF {
    xSolic: string;
    [property: string]: any;
}

export interface TNFeInfNFePag {
    detPag:  TNFeInfNFePagDetPag[];
    vtroco?: string;
    [property: string]: any;
}

export interface TNFeInfNFePagDetPag {
    card?:   TNFeInfNFePagDetPagCard;
    indPag?: IndSomaCofinsst;
    tPag:    TPag;
    vPag:    string;
    xPag?:   string;
    [property: string]: any;
}

export interface TNFeInfNFePagDetPagCard {
    cAut?:     string;
    cnpj?:     string;
    tBand?:    TBand;
    tpIntegra: IndIncentivo;
    [property: string]: any;
}

export enum TBand {
    The01 = "01",
    The02 = "02",
    The03 = "03",
    The04 = "04",
    The05 = "05",
    The06 = "06",
    The07 = "07",
    The08 = "08",
    The09 = "09",
    The10 = "10",
    The11 = "11",
    The12 = "12",
    The13 = "13",
    The14 = "14",
    The15 = "15",
    The16 = "16",
    The17 = "17",
    The18 = "18",
    The19 = "19",
    The20 = "20",
    The21 = "21",
    The22 = "22",
    The23 = "23",
    The24 = "24",
    The25 = "25",
    The26 = "26",
    The27 = "27",
    The99 = "99",
}

export enum TPag {
    The01 = "01",
    The02 = "02",
    The03 = "03",
    The04 = "04",
    The05 = "05",
    The10 = "10",
    The11 = "11",
    The12 = "12",
    The13 = "13",
    The14 = "14",
    The15 = "15",
    The16 = "16",
    The17 = "17",
    The18 = "18",
    The19 = "19",
    The90 = "90",
    The99 = "99",
}

export interface TNFeInfNFeTotal {
    icmstot:   TNFeInfNFeTotalICMSTot;
    issqNtot?: TNFeInfNFeTotalISSQNtot;
    retTrib?:  TNFeInfNFeTotalRetTrib;
    [property: string]: any;
}

export interface TNFeInfNFeTotalICMSTot {
    vbc:           string;
    vbcst:         string;
    vcofins:       string;
    vdesc:         string;
    vfcp:          string;
    vfcpst:        string;
    vfcpstret:     string;
    vfcpufdest?:   string;
    vfrete:        string;
    vicms:         string;
    vicmsdeson:    string;
    vicmsufdest?:  string;
    vicmsufremet?: string;
    vii:           string;
    vipi:          string;
    vipidevol:     string;
    vnf:           string;
    voutro:        string;
    vpis:          string;
    vprod:         string;
    vseg:          string;
    vst:           string;
    vtottrib?:     string;
    [property: string]: any;
}

export interface TNFeInfNFeTotalISSQNtot {
    cRegTrib?:    CRegTrib;
    dCompet:      string;
    vbc?:         string;
    vcofins?:     string;
    vDeducao?:    string;
    vDescCond?:   string;
    vDescIncond?: string;
    viss?:        string;
    vissRet?:     string;
    vOutro?:      string;
    vpis?:        string;
    vServ?:       string;
    [property: string]: any;
}

export enum CRegTrib {
    The1 = "1",
    The2 = "2",
    The3 = "3",
    The4 = "4",
    The5 = "5",
    The6 = "6",
}

export interface TNFeInfNFeTotalRetTrib {
    vbcirrf?:    string;
    vbcRetPrev?: string;
    virrf?:      string;
    vRetCOFINS?: string;
    vRetCSLL?:   string;
    vRetPIS?:    string;
    vRetPrev?:   string;
    [property: string]: any;
}

export interface TNFeInfNFeTransp {
    balsa?:      string;
    modFrete:    TpREST;
    reboque?:    TVeiculo[];
    retTransp?:  TNFeInfNFeTranspRetTransp;
    transporta?: TNFeInfNFeTranspTransporta;
    vagao?:      string;
    veicTransp?: TVeiculo;
    vol?:        TNFeInfNFeTranspVol[];
    [property: string]: any;
}

export interface TVeiculo {
    placa: string;
    rntc?: string;
    uf?:   TUf;
    [property: string]: any;
}

export interface TNFeInfNFeTranspRetTransp {
    cfop:     string;
    cMunFG:   string;
    picmsRet: string;
    vbcRet:   string;
    vicmsRet: string;
    vServ:    string;
    [property: string]: any;
}

export interface TNFeInfNFeTranspTransporta {
    cnpj:    string;
    cpf:     string;
    ie?:     string;
    uf?:     TUf;
    xEnder?: string;
    xMun?:   string;
    xNome?:  string;
    [property: string]: any;
}

export interface TNFeInfNFeTranspVol {
    esp?:    string;
    lacres?: TNFeInfNFeTranspVolLacres[];
    marca?:  string;
    nVol?:   string;
    pesoB?:  string;
    pesoL?:  string;
    qVol?:   string;
    [property: string]: any;
}

export interface TNFeInfNFeTranspVolLacres {
    nLacre: string;
    [property: string]: any;
}

export interface TNFeInfNFeSupl {
    qrCode:   string;
    urlChave: string;
    [property: string]: any;
}

export interface SignatureType {
    id?:            string;
    keyInfo:        KeyInfoType;
    signatureValue: SignatureValueType;
    signedInfo:     SignedInfoType;
    [property: string]: any;
}

export interface KeyInfoType {
    id?:      string;
    x509Data: X509DataType;
    [property: string]: any;
}

export interface X509DataType {
    x509Certificate: number[];
    [property: string]: any;
}

export interface SignatureValueType {
    id?:    string;
    value?: number[];
    [property: string]: any;
}

export interface SignedInfoType {
    canonicalizationMethod: SignedInfoTypeCanonicalizationMethod;
    id?:                    string;
    reference:              ReferenceType;
    signatureMethod:        SignedInfoTypeSignatureMethod;
    [property: string]: any;
}

export interface SignedInfoTypeCanonicalizationMethod {
    algorithm: string;
    [property: string]: any;
}

export interface ReferenceType {
    digestMethod: ReferenceTypeDigestMethod;
    digestValue:  number[];
    id?:          string;
    transforms:   TransformsType;
    type?:        string;
    uri:          string;
    [property: string]: any;
}

export interface ReferenceTypeDigestMethod {
    algorithm: string;
    [property: string]: any;
}

export interface TransformsType {
    transform: TransformType[];
    [property: string]: any;
}

export interface TransformType {
    algorithm: Algorithm;
    xPath?:    string[];
    [property: string]: any;
}

export enum Algorithm {
    HTTPWWWW3Org200009XmldsigEnvelopedSignature = "http://www.w3.org/2000/09/xmldsig#enveloped-signature",
    HTTPWWWW3OrgTR2001RECXMLC14N20010315 = "http://www.w3.org/TR/2001/REC-xml-c14n-20010315",
}

export interface SignedInfoTypeSignatureMethod {
    algorithm: string;
    [property: string]: any;
}
